import { api } from "../../api/fetch";
import { TestSuite } from '../entity';

export const deleteTestSuite = async (testSuite: TestSuite) => {
    return  await api.delete(`/api/v1/test-suites/${testSuite.id}`);
}

export default deleteTestSuite;
